import type { Config } from '@utils/config';

const getConfig = (): Config => ({
  serverUrl: 'https://sso.d2dasia.com/api/v1',
  kikanUrl: 'https://www.fcstandard.co.jp',
  d2dFrontendZendeskUrl: 'https://d2d-frontend-zendesk.pages.dev',
  zendeskEnabled: true,
  zendeskDashboard: 'https://dxd1688.zendesk.com',
  dev:
    process.env.NODE_ENV === 'production'
      ? undefined
      : {
          accounts: [
            {
              tag: 'Admin',
              email: 'wangchenyu2017@gmail.com',
              password: 'rxT6zVgTLU',
            },
            {
              tag: 'Superuser',
              email: 'admin@fcstandard.com',
              password: 'JaSfDCDt',
            },
            {
              tag: 'Freightman',
              email: 'yanrumao131+6@gmail.com',
              password: 'd2dd2dd2d',
            },
            {
              tag: 'Ryou Admin',
              email: 'k_ryou@fcstandard.com',
              password: 'Ryou5577',
            },
          ],
          // email: 'liu_yuchen@lifestyle-co.fun',
        },
});

export default getConfig;
